module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-inside"
    }
  }, [(_vm.textPage !== null) ? _c('textPage') : _vm._e(), _vm._v(" "), (this.$store.state.spotAtDistance !== null && (_vm.$route.name === 'map' || _vm.$route.name === 'profile')) ? _c('spotdistance', {
    attrs: {
      "spot": this.$store.state.spotAtDistance
    }
  }) : _vm._e(), _vm._v(" "), (_vm.locationError && _vm.currentRoute !== 'start') ? _c('errupt') : _vm._e(), _vm._v(" "), (_vm.interupt !== null) ? _c('interupt') : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'start' && _vm.$route.name !== 'tutorial') ? _c('location') : _vm._e(), _vm._v(" "), _c('auth'), _vm._v(" "), (_vm.infoMenu) ? _c('info-menu') : _vm._e(), _vm._v(" "), (_vm.singlePhoto !== null) ? _c('photo') : _vm._e(), _vm._v(" "), (_vm.showingPhotoUpload) ? _c('photo-upload') : _vm._e(), _vm._v(" "), (_vm.showingOverlay === true) ? _c('spot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingPhotoUpload === false),
      expression: "showingPhotoUpload === false"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.textPage === null) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-rotate-fade"
    }
  }, [(_vm.showMenu === false && _vm.$route.name === 'map') ? _c('div', {
    staticClass: "float-toggle",
    on: {
      "click": function($event) {
        _vm.$store.commit('changeShowMenu', true)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showMenu === true && _vm.$route.name === 'map') ? _c('float-menu') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-033d1ee0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 105
// module chunks = 0